import React, { useEffect, useRef } from 'react';
import { CollapseBlock } from '../../../../common/index.jsx';
import FormTextEditor from '../../../../antd/form/FormTextEditor/FormTextEditor.jsx';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField.jsx';
import { documentTypes } from '../../../../../hooks/useFileDraggerFileValidation.jsx';
import PropTypes from 'prop-types';
import {
  validateFieldFunc,
  formIsEmpty as formLanguageIsEmpty,
  formIsFilled as formLanguageIsFilled,
} from '../../../../../utils/helpers/validation.jsx';
import { useTranslation } from 'react-i18next';
import FormSelect from '../../../../antd/form/FormSelect/FormSelect.jsx';
import { Form } from 'antd';
const LanguageBlock = ({
  language,
  title,
  onChange,
  positionOptions,
  showPredefined,
  form,
}) => {
  const { t } = useTranslation();
  const currentLanguageFormIsEmpty = formLanguageIsEmpty(
    form,
    language,
    'label',
    'position',
    showPredefined,
  );
  const currentLanguageFormIsFilled = formLanguageIsFilled(
    form,
    language,
    'label',
    'position',
    showPredefined,
  );
  const validator = validateFieldFunc(
    currentLanguageFormIsEmpty,
    currentLanguageFormIsFilled,
    t,
  );

  const labelValue = Form.useWatch(`label_${language}`, { form, preserve: true });
  const hasLabel = typeof labelValue === 'string'
    ? labelValue.trim() !== ''
    : Boolean(labelValue);
  const previousHasLabelRef = useRef(hasLabel);

  useEffect(() => {
    // Clear position only when user changes label from filled to empty.
    if (previousHasLabelRef.current && !hasLabel) {
      form.setFieldValue(`position_${language}`, null);
      onChange(null, 'position', language);
    }

    previousHasLabelRef.current = hasLabel;
  }, [hasLabel, form, language, onChange]);

  return (
    <CollapseBlock collapsible collapse={false} title={title}>
      <FormTextField
        className={'note-to-field'}
        label={<label className={'note-to-field'}>{t(`Názov`)}</label>}
        name={`label_${language}`}
        rules={[{ validator: validator }]}
        onChange={(e) => onChange(e.target.value, 'label', language)}
      />
      <FormSelect
        label={
          <label className={'note-to-field'}>{t('Pozícia na stránke')}</label>
        }
        name={`position_${language}`}
        options={positionOptions}
        rules={[{ validator: validator }]}
        onChange={(e) => onChange(e, 'position', language)}
        disabled={!hasLabel}
      />
      {!showPredefined && (
        <FormTextEditor
          label={<label className={'note-to-field'}>{t(`Obsah`)}</label>}
          name={`content_${language}`}
          rules={[{ validator: validator }]}
          imgUploadDirectory={'blocks'}
          fileUploadDirectory={'blocks'}
          allowedTypes={documentTypes}
          onChange={(e) => onChange(e, 'content', language)}
        />
      )}
    </CollapseBlock>
  );
};
LanguageBlock.propTypes = {
  language: PropTypes.string,
  title: PropTypes.string,
  onChange: PropTypes.func,
  positionOptions: PropTypes.array,
  showPredefined: PropTypes.bool,
  form: PropTypes.object,
};

export default LanguageBlock;
